import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TopBar from "./components/TopBar";
import AboutUs from './components/AboutUs'
import Stats from "./components/Stats";
import Services from "./components/Services/Services";
import Appointment from "./components/Appointment";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import PromoPopup from "./components/PromoPopup";


function App() {
  return (
    <div className="app">
      <PromoPopup/>
      <TopBar />
      <Navbar />

      <main>
        <Hero />
        <AboutUs />
        <Stats />
        <Services />
        <Appointment />
        <ContactUs /> 

   
      </main>
      <Footer/>
    </div>
  );
}

export default App;
